import { PlusOutlined, MoreOutlined, DeleteOutlined, FormOutlined } from '@ant-design/icons'
import { makeStyles } from '@material-ui/core'
import {Space, Table, Popconfirm, Button, notification } from 'antd'
import moment from 'moment'
import React, {useEffect, useState} from 'react'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useData } from '../../../../data'
import { CTAButton } from '../../components'
import NewRelevantTitle from './new'
import UpdateRelevantTitle from './edit'

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    },
    topBar: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    topButton: {
        width: '80%',
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    content: {
        padding: theme.spacing(3, 0)
    },
    table: {
        maxWidth: '100%',
        width: '100%'
    }
}))


/**
 * page to add variations
 */
const RelevantTitles = (props) => {
    const [relevantTitles, setRelevantTitles] = useState([])
    const [show, setShow] = useState(false)
    const [editShow, setEditShow] = useState(false)
    const [title, setTitle] = useState({})
    const [error, setError] = useState(null)
    const classes = useStyles()
    const data = useData()
    const titles = data.titles()

    const newTitle = () => setShow(true)
    const updateTitle = (record) => {
            setEditShow(true);
            setTitle(record);
        }

    const getFilterValues = (dataSource, dataIndex) => {
        return Array.from(new Set(dataSource.map(item => {
            const value = item[dataIndex]?.initial?.toLowerCase()
            return value ? value.charAt(0).toUpperCase() + value.slice(1) : null // Capitalize the initial letter for display
        }).filter(Boolean))) // Remove null, undefined, and empty string values
        .sort()
        .map(value => ({ text: value, value }));
    }

    const relevantTitleSchema = [
        {
            title: 'ID',
            key: 'id',
            dataIndex: 'id'
        },
        {
            title: 'Initial',
            key: 'initial',
            dataIndex: 'initial',
            filters: getFilterValues(relevantTitles, 'initial'), // Assuming unclearTitles is your dataSource
            onFilter: (value, record) => {
                const recordValue = record.initial?.initial?.toLowerCase() || "";
                return recordValue === value.toLowerCase();
            },
            sorter: (a, b) => {
                // Handle the case where end or end.initial might be null/undefined
                const aInitial = (a.initial && a.initial.initial && a.initial.initial.toLowerCase()) || "";
                const bInitial = (b.initial && b.initial.initial && b.initial.initial.toLowerCase()) || "";
              
                // Use localeCompare to sort the values
                return aInitial.localeCompare(bInitial);
            },
            render: initial => {
                if (!initial) {
                    return null;
                }
                return (
                    <div>
                        <b>{initial.initial}</b> - {initial.variations}
                    </div>
                );
            }
        },
        {
            title: 'Main',
            key: 'main',
            dataIndex: 'main',
            filters: getFilterValues(relevantTitles, 'main'), // Assuming unclearTitles is your dataSource
            onFilter: (value, record) => {
                const recordValue = record.main?.initial?.toLowerCase() || "";
                return recordValue === value.toLowerCase();
            },
            sorter: (a, b) => {
                // Handle the case where end or end.initial might be null/undefined
                const aInitial = (a.main && a.main.initial && a.main.initial.toLowerCase()) || "";
                const bInitial = (b.main && b.main.initial && b.main.initial.toLowerCase()) || "";
              
                // Use localeCompare to sort the values
                return aInitial.localeCompare(bInitial);
            },
            render: main => (
                <div>
                    <b>{main.initial}</b> - {main.variations}
                </div>
            ),
        },
        {
            title: 'End',
            key: 'end',
            dataIndex: 'end',
            filters: getFilterValues(relevantTitles, 'end'), // Assuming unclearTitles is your dataSource
            onFilter: (value, record) => {
                const recordValue = record.end?.initial?.toLowerCase() || "";
                return recordValue === value.toLowerCase();
            },
            sorter: (a, b) => {
                // Handle the case where end or end.initial might be null/undefined
                const aInitial = (a.end && a.end.initial && a.end.initial.toLowerCase()) || "";
                const bInitial = (b.end && b.end.initial && b.end.initial.toLowerCase()) || "";
              
                // Use localeCompare to sort the values
                return aInitial.localeCompare(bInitial);
            },
            render: end => {
                if (!end) {
                    return null;
                }
                return (
                    <div>
                        <b>{end.initial}</b> - {end.variations}
                    </div>
                );
            }
        },
        {
            title: 'Date Created',
            key: 'created_at',
            dataIndex: 'created_at',
            render: (date) => moment(date).format("YYYY-MM-DD HH:mm")
        },
        {
            title: 'Date Updated',
            key: 'updated_at',
            dataIndex: 'updated_at',
            render: (updated_at) => moment(updated_at).format("YYYY-MM-DD HH:mm")
        },
        {
            key: 'Actions',
            title: 'Actions',
            render: (_, record) => {
                return (
                <Space>
                    <Button type='primary' size='small' onClick={() => updateTitle(record)}  icon={<FormOutlined />} />
                    <Popconfirm
                        title="Are you sure to delete this relevant title?"
                        onConfirm={ () => deleteRelevantTitles(record.id) }
                        okText="Yes"
                        cancelText="No"
                    >
                    <Button danger size='small'  icon={<DeleteOutlined />} />
                    </Popconfirm>
                </Space>
                )
            }
        },
    ]

    const deleteRelevantTitles = ( id ) => {
        titles.deleteRelevantTitle(id)
            .then((data) => {
                notification.success({
                    message: "Relevant titles deleted successfully."
                })
                loadRelevantTitles()
            })
    }

    const loadRelevantTitles = () => {
        trackPromise(
            titles.getRelevantTitles()
                .then(a => {
                    console.log(a)
                    setRelevantTitles(a)
                })
                .catch(console.log)
        )
    }

    const publishRelevantTitles = () => {
        setError(null)
        trackPromise(
            titles.publishTitles("relevant")
            .then(a => {
                console.log(a)
                notification.success({
                    message: "Relevant titles published successfully."
                })
            })
            .catch(err => {
                console.log(err.message)
                setError("An error occured")
            })
        )
    }

    // load the relevant titles
    useEffect(() => {
        loadRelevantTitles()
    }, [])

    const {promiseInProgress} = usePromiseTracker()

    const closeDrawer = () => {
        setShow(false)
        setEditShow(false)
        loadRelevantTitles()
    }

    return (
        <div className={classes.root}>
            <div className={classes.topBar}>
                <h1>Relevant Titles</h1>
                <div className={classes.topButton}>
                    <div style={{marginRight: 10}}>
                        <Popconfirm
                            title="Are you sure to publish all relevant titles?"
                            onConfirm={ () => publishRelevantTitles() }
                            okText="Yes"
                            cancelText="No"
                        >
                            <CTAButton onClick={null} type={"submit"} >
                            Publish Relevant Title
                            </CTAButton>
                    
                        </Popconfirm>
                    </div>
                    <CTAButton onClick={newTitle}>
                        <PlusOutlined />
                        Add Relevant Title
                    </CTAButton>
                </div>
                
            </div>

            <div className={classes.content}>
                <Table
                    columns={relevantTitleSchema}
                    className={classes.table}
                    loading={promiseInProgress}
                    dataSource={relevantTitles}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 20,
                        total: relevantTitles.length,
                        pageSizeOptions: ['10', '20', '50', '100', '200', '500'],
                        showTotal: (total, range) => `Showing ${range[0]}-${range[1]} of ${total} titles`,
                    }}
                />
            </div>

            <NewRelevantTitle visible={show} close={closeDrawer} />
            <UpdateRelevantTitle title={title} visible={editShow} close={closeDrawer}/>
        </div>
    )
}

export default RelevantTitles